import { render, staticRenderFns } from "./SupplierAccreditationExpireReport.vue?vue&type=template&id=b0fdb598&scoped=true&"
import script from "./SupplierAccreditationExpireReport.vue?vue&type=script&lang=js&"
export * from "./SupplierAccreditationExpireReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fdb598",
  null
  
)

export default component.exports